import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { SessionStorageProps } from '@commoncore/enums/sessionStorageProps';
import { GlobalService } from '@commoncore/services/global.service';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';

@Component({
  standalone:true,
  selector: 'lib-purchase-success',
  templateUrl: './purchase-success.component.html',
  styleUrls: ['./purchase-success.component.scss'],
  imports:[DependenciesModule]
})
export class PurchaseSuccessComponent implements OnInit, OnDestroy {
  universalService:any;
  @Input() modalType:any ="";
  @Output() closeModal = new EventEmitter();
  router:any;
  sessionStorageService: any;

  constructor(public globalService:GlobalService) {
    this.setEnvObjects(globalService);
   }

   @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && this.modalType != "" && !this.universalService.show2FApopUp) {
      this.closePopUp();
    }else if(event.key === "Enter" && this.modalType != "" && !this.universalService.show2FApopUp){
      if(this.modalType == "JioSim"){
        this.getJioSim();
      }else if (this.modalType == "plan-purchase"){
        this.closePopUp();
      }
    }
  }

  ngOnInit(): void {
    this.universalService.showLoader = false;
    localStorage.removeItem("planPurchaseSuccess");
    document.body.style.overflow = 'hidden';
  }

  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.router = globalService.getRouterRef();
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
  }

  closePopUp(){
    this.sessionStorageService.removeSessionProperty(SessionStorageProps.BUY_STORAGE);
    this.closeModal.emit();
  }

  getJioSim(){
    this.closePopUp();
    this.universalService.purchaseModalType = "";
    this.universalService.planPurchaseInitiated = false;
    window.open(ENV_CONFIG["thirdpartyUrls"]["myjio"],"_blank", "noopener, noreferrer");
    if(this.router.url.includes('/pricing')){
      this.universalService.purchaseModalType = "";
      this.router.navigate(['/home']);
    }
  }

  ngOnDestroy(){
    document.body.style.overflow = 'auto';
   }

}
